import React from 'react'
import {useAsyncValue} from '../../../hooks/useAsyncValue'
import {ImageUpload} from '../ImageUpload'
import {instance as eventsService} from '../../../services/PlantEventsJournalService'

export type ImagePreviewProps = {
  photosIds: string[]
}

export function ImagePreview(props: ImagePreviewProps) {
  const {
    value: signedPhotoURLs,
    isLoading: signedPhotoURLsLoading,
    reload: reloadSignedPhotoURLs,
  } = useAsyncValue(null, () => eventsService.getPlantEventImageURLs(props.photosIds), [
    props.photosIds,
  ])

  if (signedPhotoURLs === null) {
    return null
  }

  return (
    <div>
      <ImageUpload
        fileList={props.photosIds.map((photoName, index) => ({
          uid: index,
          photoName: photoName,
          name: index,
          status: 'done',
          url: signedPhotoURLs.urls[index],
        }))}
        addable={false}
      />
    </div>
  )
}
